
import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
import "./AddSubCategory.scss"
import Toast from "components/Toast"
import { getAllSubCategoriesInfo } from "core/services/api/billingService"


function ViewSubCategoryInfo() {
  const history = useHistory()
  const [displayToast, toggleToast] = useState<any>()

  const [data, setData] = useState<any>();
  useEffect(() => {
    getAllSubCategoriesInfo().then((res: any) => {
      console.log(res, "res");
      setData(res);
    }).catch((err: any) => {
      console.log(err, "Err");
    })

  }, [])

  const namesByType: any = {};
  data?.forEach((item: any) => {
    const { type, name } = item;
    if (!namesByType[type]) {
      namesByType[type] = [];
    }
    namesByType[type].push(name);
  });


  return (
    <div className="add-new-view-container">

      <table className="styled-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Sub Category</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(namesByType).map(([type, names]: any) => (
            <React.Fragment key={type}>
              <tr>
                <td><strong>{type}</strong></td>
                <td>{names.join(", ")}</td>

              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>


      {
        displayToast && (
          <Toast
            textMessage={displayToast?.text}
            onClose={() => { toggleToast(false) }}
            onCloseText={"Close"}
            onClickText={null}
            onClick={() => history.push("/ContactReferrals")}
            type={displayToast?.type}
          />
        )
      }
    </div >
  )
}

export default ViewSubCategoryInfo